import styled from "styled-components";

export const ImgStyle = styled.div`
    img{
    
     width: 5rem;
    border: 2px solid brown;
    border-radius: 50px;
    }
`